module.exports = __webpack_public_path__ + "img/2.251d9d8e.png";